import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../authentication/auth.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ACCESS_TYPE, Actuator, Device, FORM_TYPE, MetaData, PROCESS_TYPE, PROPERTY_TYPE, SECTIONS, Sensor} from '../models';
import {AccountService} from '../account/account.service';
import {ToastrService} from 'ngx-toastr';
import {SideNavService} from '../sidenav/sidenav.service';
import {Paho} from 'ng2-mqtt/mqttws31';
import moment from 'moment-timezone';
import {ActivatedRoute} from '@angular/router';

declare function toggleClass(id, className): any;

declare function removeClass(id, className): any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  formDevice: FormGroup;
  formType;
  devicesOfKit: Device[] = [];
  isSubmitted: boolean;
  error;
  propertyType = PROPERTY_TYPE;
  processTypes = PROCESS_TYPE;
  propertyCalMethod = ['SUM', 'MIN', 'MAX', 'AVE', 'PREDICT', 'ANY'];
  dropdownSettings;
  sensorsOfDevice: Sensor[] = [];
  actuatorsOfDevice: Actuator[] = [];
  devices: Device [];
  batches=[]
  devicesAll: Device [] = [];
  selectedDeviceId;
  p = 1;

  sensorsOfKitModel = [];
  showKitForm = false;
  showKitModelForm = false;
  isDataFetched = false;
  actuators;
  sensors;
  metaData: MetaData;
  devicesSummary;
  searchTerm = '';
  isCloning = false;
  selectedDevice: Device;
  // mqtt
  mqttClient;
  clicked = '';

  ACCESS_TYPE = ACCESS_TYPE;
  SECTION = SECTIONS;

  coperateId;
  filter;
  favourite;

  constructor(private formBuilder: FormBuilder, private spinner: NgxSpinnerService,
              private accountService: AccountService, private toaster: ToastrService,
              private sideNavService: SideNavService,private router: ActivatedRoute) {
    // this.mqttClient = new Paho.MQTT.Client('mqtt.senzmate.com', 8000, 'manualIrr' + new Date().getTime());
    // this.mqttClient.connect({onSuccess: this.onConnected.bind(this)});

  }

  // onConnected() {
  //   this.subscribeToMqtt();
  //
  //   this.mqttClient.onMessageArrived = (message: Paho.MQTT.Message) => {
  //     const data = JSON.parse(message.payloadString);
  //     console.log(data);
  //     if (data) {
  //       this.devicesSummary = data;
  //       this.getDevices(true);
  //     }
  //   };
  //
  //   this.mqttClient.onConnectionLost = (responseObject: 'Object') => {
  //     this.mqttClient.connect({onSuccess: this.onConnected.bind(this)});
  //   };
  // }

  // subscribeToMqtt() {
  //   if (this.mqttClient.isConnected()) {
  //     this.mqttClient.unsubscribe(`S2F/M/V1/deviceSummary`);
  //     this.mqttClient.subscribe(`S2F/M/V1/deviceSummary`);
  //   }
  // }

  ngOnInit() {

    this.router.params.subscribe(params => {
      this.coperateId = params['coperateId'];
      this.filter=params['filter']
      this.favourite=params['favourite']
    });

    this.formDevice = this.formBuilder.group({
      id: [null, Validators.required],
      name: [null, Validators.required],
      interval: [null, [Validators.required, Validators.pattern('^[1-9]{1}[0-9]*$'), Validators.min(0)]],
      persistence: [null, Validators.required],
      protocol: [null, Validators.required],
      connectivity: [null, Validators.required],
      batchNumber:[null, Validators.required]
    });
    this.getDevicesSummary();
    this.getDevices();
    this.getMetaData();
    this.getBatches();
    // this.onConnected();

  }

  public pageChange(event: number): void {
    this.p = event;
  }


  isSuperUser() {
    return AuthService.isSuperAdmin();
  }

  createDevice(device) {
    Object.keys(this.formDevice.controls).forEach((key) => {
      if (typeof device[key] === "string") {
        device[key] = device[key].trim();
      }
    }
    );
    
    this.isSubmitted = true;
    if (!this.formDevice.valid || !this.isSuperUser()) {
      return;
    }

    this.spinner.show();
    this.error = null;
    device.sensorCodes = this.sensorsOfDevice.map(s => s.code);
    device.actuatorCodes = this.actuatorsOfDevice.map(a => a.code);
    device.noOfSensors = this.sensorsOfDevice.length;
    device.noOfActuators = this.actuatorsOfDevice.length;
    if (this.formType === FORM_TYPE.ADD || this.isCloning) {
      this.accountService.createDevice(device).subscribe(response => {
        // this.spinner.hide();
        this.getDevices();
        toggleClass('addDevice', 'hide');
        this.toaster.success('Device Created Successfully', 'Success');
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      }, () => {
        this.isCloning = this.isCloning ? !this.isCloning : this.isCloning;
      });
    } else {
      this.accountService.updateDevice(this.selectedDeviceId, device).subscribe(response => {
        this.getDevices();
        toggleClass('addDevice', 'hide');
        this.toaster.success('Device Updated Successfully', 'Success');
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
    }
    this.isSubmitted = false;
  }

  deleteDevice() {
    this.spinner.show();
    this.accountService.deleteDevice(this.selectedDevice.id).subscribe(response => {
      this.toggleHideById('deleteModal');
      this.devicesAll.splice(this.devicesAll.indexOf(this.selectedDevice), 1);
      this.spinner.hide();
      this.toaster.success('Device Deleted Successfully', 'Success');
    }, error => {
      this.toggleHideById('deleteModal');
      this.spinner.hide();
      if (error.status === 422) {
        this.error = error.error.message;
      } else {
        this.toaster.error('Oops... Something went wrong', 'Error!');
      }
    });
  }

  editDevice(device) {
    this.formDevice.reset();
    this.formDevice.patchValue(device);
    this.sensorsOfDevice = device.sensorCodes ? device.sensorCodes.map(s => this.getSensorByCode(s)) : [];
    this.actuatorsOfDevice = device.actuatorCodes ? device.actuatorCodes.map(s => this.getActuatorByCode(s)) : [];
    if (!this.isCloning) {
      this.formDevice.controls['id'].disable();
    }
    this.formType = FORM_TYPE.EDIT;
    this.selectedDeviceId = device.id;
    this.error = null;
    this.isSubmitted = false;
    this.getDevices();
    toggleClass('addDevice', 'hide');
  }

  getDevices(isSilent?) {
    if (!isSilent) {
      this.spinner.show();
    }
    this.accountService.getOneDevice(this.coperateId,this.filter,this.favourite).subscribe(response => {
      this.devices = response.content;
      this.devicesAll = Object.assign([], this.devices);
      this.devices.sort((a, b) => {

        if (!a.name || !b.name) {
          return 1;
        }
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      });
      if (this.devicesSummary) {
        this.devicesSummary.alive = {noOfDevice: 0, deviceList: []};
        this.devicesSummary.noDevicesOffline = {noOfDevice: 0, deviceList: []};

        this.devices.forEach(device => {
          if (this.isDeviceOnline(device.lastSeen, device.interval)) {
            this.devicesSummary.alive.noOfDevice++;
            this.devicesSummary.alive.deviceList.push(device.id);
          } else if (device.lastSeen) {
            this.devicesSummary.noDevicesOffline.noOfDevice++;
            this.devicesSummary.noDevicesOffline.deviceList.push(device.id);
          }
        });
      }

      this.isDataFetched = true;
    }, error => {
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    });
  }

  isDeviceOnline(time, interval) {
    if (!time) {
      return false;
    }
    const ist = moment.tz(time, 'Asia/Colombo');
    const ut = ist.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    return moment().diff(ut) / (1000 * 60) <= interval;
  }

  getMetaData() {
    this.spinner.show();
    this.accountService.getMetaData().subscribe((data) => {
      this.metaData = data.content;
      this.sensors = this.metaData.sensors.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });

      this.actuators = data.content.actuators.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
    }, () => {
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    });
  }

  getDevicesSummary() {
    this.spinner.show();
    this.accountService.getDevicesSummary().subscribe((data) => {
      this.devicesSummary = data.content;
    }, () => {
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    });
  }

  getBatches(){
    this.spinner.show();
    this.accountService.getBatches().subscribe((data) => {
      this.batches = data.content;
    }, () => {
      this.spinner.hide();
    }, () => {
      this.spinner.hide();
    });
  }

  isBatterySelected() {
    return this.sensorsOfDevice.includes(this.getSensorByCode('B'));
  }

  getPropertyCalMethod() {
    return this.propertyCalMethod;
  }

  getProcessTypes() {
    return Object.keys(this.processTypes).map(o => {
      return String(o);
    });
  }

  getWindowWidth() {
    return window.innerWidth;
  }

  getDeviceFormReady() {
    this.formType = FORM_TYPE.ADD;
    this.isSubmitted = false;
    this.formDevice.reset();
    this.formDevice.patchValue({
      persistence: true,
      protocol: 'HTTP',
      connectivity: 'GSM',
    });
    this.formDevice.controls['id'].enable();
    this.sensorsOfDevice = [];
    toggleClass('addDevice', 'hide');
  }

  getKitFormReady() {
    this.formType = FORM_TYPE.ADD;
    this.showKitForm = true;
  }

  getKitModelFormReady() {
    this.formType = FORM_TYPE.ADD;
    this.showKitModelForm = true;
  }

  getSensorsSelected() {
    const temp = [];
    this.sensorsOfKitModel.forEach(function (s, index) {
      temp.push({item_id: index, item_text: s.name + ' ' + (index + 1)});
    });
    return temp;
    // return Array.from({length: this.sensorsOfKitModel.length}, (v, k) => String(k));
  }

  addSensorToDevice(index) {
    this.sensorsOfDevice.push(this.sensors[index]);
  }

  removeSensorFromDevice(index) {
    this.sensorsOfDevice.splice(index, 1);
  }

  addActuatorToDevice(index) {
    this.actuatorsOfDevice.push(this.actuators[index]);
  }

  removeActuatorFromDevice(index) {
    this.actuatorsOfDevice.splice(index, 1);
  }

  addDeviceToKit(index) {
    this.devicesOfKit.push(this.devices.splice(index, 1)[0]);
  }

  removeDeviceFromKit(index: number) {
    this.devices.push(this.devicesOfKit.splice(index, 1)[0]);
    this.devices.sort((a, b) => {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    });
  }

  // getDeviceById(id) {
  //   return this.devices.filter((device) => {
  //     return device.id === id;
  //   })[0];

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  hasLeastSensorOfProperty(property: String): boolean {
    return this.sensorsOfKitModel.includes(property);
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  onClearError() {
    this.error = null;
  }

  getSensorByCode(sensor) {
    return this.sensors.filter(s => {
      return s.code === sensor;
    }, 1)[0];
  }

  private getActuatorByCode(actuator) {
    return this.actuators.filter(a => {
      return a.code === actuator;
    }, 1)[0];
  }

  getDevicesFiltered() {
    if (this.clicked !== '' && this.devicesSummary) {
      // tslint:disable-next-line:max-line-length
      return this.devicesAll.filter(k => this.devicesSummary[this.clicked].deviceList.includes(k.id)).filter(d => JSON.stringify(Object.values(d)).toLowerCase().includes(this.searchTerm.trim().toLowerCase()));
    } else {
      return this.devicesAll.filter(d => JSON.stringify(Object.values(d)).toLowerCase().includes(this.searchTerm.trim().toLowerCase()));
    }

  }

  toggleHideById(id) {
    document.getElementById('deleteModal').classList.toggle('hide');
  }


  isActive(value) {
    if (this.clicked === '') {
      this.clicked = value;
    } else if (this.clicked === value) {
      this.clicked = '';
    } else if (this.clicked !== '' && this.clicked !== value) {
      this.clicked = value;
    }
  }
}
